import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Box,
  Button,
  DataTable,
  FormField,
  Heading,
  Layer,
  Main,
  Select,
  Text,
  Menu,
  Calendar,
  TextInput,
  Tip
} from 'grommet'
import update from 'immutability-helper'
import { buildBody, getMonthEnd } from '../libs/appsSheet'

import GridLoader from 'react-spinners/GridLoader'
import { Filter, MoreVertical, SchedulePlay } from 'grommet-icons'
import { AppContext } from '../libs/context'
import { DropWithHeading, FileDataRowDetails, PageHeader } from './Common'
import { appSheet } from '../api/retail'
import GeneratedFiles from './GeneratedFiles'
import { DocumentDownload } from 'grommet-icons/es6'
import { SelectSupplierReceiver } from './Select'

class PublishFiles extends Component {
  static contextType = AppContext
  defaultState = {
    files: [],
    // companiesById: {},
    processing: {},
    completed: {},
    submitting: false,
    nextStartIndex: 0,
    totalChunks: 0,
    chunking: false,
    showLayer: false,
    showStatus: 'QUEUE',
    requestedFiles: 0,
    apiLoading: false,
    selectedFileCount: 1,
    selectedChunkSize: 1,
    selectedCompanyId: '',
    selectedReceiverId: '',
    selectedCustomIds: [],
    showJobSettings: false,
    startAtId: '',
    text: ''
  }
  state = { ...this.defaultState, selectedDate: getMonthEnd() }

  getPublishFiles = () => {
    const { selectedCompanyId, selectedReceiverId, showStatus, selectedDate } = this.state
    let queryFilters = [
      "[file_status] = '" + showStatus + "'",
      ["[entry_date] = '" + selectedDate.slice(0, 10) + "'"]
    ]
    if (selectedCompanyId) {
      queryFilters.push('[company_id] = ' + selectedCompanyId)
    }
    if (selectedReceiverId) {
      queryFilters.push('[receiver_id] = ' + selectedReceiverId)
    }
    let selector = ''
    queryFilters.forEach((item) => (selector += item + ','))

    // What a selector may look like if using the EOMONTH expression
    // "Selector": "Filter(PublishFile, AND([file_status] = 'UPDATED', [entry_date] < (EOMONTH(TODAY(), -1))))",

    const properties = {
      Selector: 'Filter(PublishFile, AND(' + queryFilters + '))'
    }

    // return postToAppSheet('PublishFile', buildBody('Find', properties))
    return appSheet.postAction('PublishFile', buildBody('Find', properties))
  }

  getCompanies = () => {
    return appSheet.postAction('Company', buildBody('Find'))
    // return postToAppSheet('Company', buildBody('Find'))
  }
  buildTaskName = (id = '', taskSize = 1) => {
    const { selectedCompanyId, selectedReceiverId } = this.state
    let tag = ''
    if (selectedCompanyId) {
      tag = 'publish_company_' + selectedCompanyId
    } else if (selectedReceiverId) {
      tag = 'publish_receiver_' + selectedReceiverId
    } else if (taskSize === 1 && id) {
      tag = 'publish_id_' + id
    } else {
      tag = 'publish_all'
    }
    return tag
  }
  advancePublishFiles = (ids, taskName) => {
    console.log('advancePublishFiles: ', taskName)
    const rows = ids.map((id) => {
      return { id: id }
    })

    return appSheet.postBatchAction(
      'PublishFile',
      buildBody('AdvanceSingleFileChangeTime', {}, rows, {
        taskName: taskName,
        requestInParallel: this.state.selectedChunkSize
      })
    )
    // return postToAppSheet('PublishFile', buildBody('AdvanceSingleFileChangeTime', {}, rows))
  }
  getFileIds = (indicies) => {
    return indicies.map((id) => this.state.files[id].id)
  }
  processIndicies = () => {
    const {
      files,
      nextStartIndex,
      chunkSize,
      totalChunks,
      requestedFiles,
      selectedCustomIds
    } = this.state
    console.log('chunkSize', chunkSize, this.getMaxAllowedFiles(), requestedFiles)
    if (totalChunks < 1) {
      console.warn('nothing to process')
      return
    }
    const indicies = []
    let i
    if (selectedCustomIds.length === 0) {
      for (
        i = nextStartIndex;
        i < nextStartIndex + chunkSize && i < this.getMaxAllowedFiles();
        i++
      ) {
        files[i] && indicies.push(i)
      }
    }

    const processingItems = {}
    let processingFileIds = []
    const completedItems = {}
    let lastIndex = nextStartIndex

    if (indicies.length > 0 || selectedCustomIds.length > 0) {
      if (selectedCustomIds.length > 0) {
        processingFileIds = [...selectedCustomIds]
      } else {
        indicies.forEach((index) => {
          const id = files[index].id
          processingItems[id] = index
          processingFileIds.push(id)
          if (lastIndex < index) {
            lastIndex = index
          }
        })
      }
      const resetState = {
        processing: {},
        totalChunks: 0,
        chunkSize: 0,
        submitting: false
      }
      const { actions } = this.context
      const taskName = this.buildTaskName(processingFileIds[0], processingFileIds.length)
      const existingTaskJob = actions.getFirebaseJob(taskName)
      console.log('processing:', indicies, processingItems, totalChunks, taskName, existingTaskJob)
      const statusTypes = ['started', 'progressing', 'initialized']
      if (existingTaskJob && statusTypes.indexOf(existingTaskJob.status) > -1) {
        actions.showResponseAsError({
          response: {
            data: { name: 'Publish Files', message: 'Job already in queue: ' + taskName }
          }
        })
        this.setState(resetState)
        return
      }
      this.setState({ processing: processingItems, submitting: true })
      this.advancePublishFiles(processingFileIds, taskName)
        .then((result) => {
          result.data.data.Rows.forEach((row) => {
            const index = processingItems[row.id]
            if (index !== undefined) {
              completedItems[row.id] = index
            }
          })
          this.setState({
            totalChunks: totalChunks > 0 ? totalChunks - 1 : 0,
            processing: {},
            submitting: false,
            completed: update(this.state.completed, {
              $merge: completedItems
            }),
            nextStartIndex: lastIndex + 1
          })
        })
        .catch((err) => {
          this.context.actions.showResponseAsError(err)

          this.setState(resetState)
        })
    }
  }
  advance = (numberOfFiles = 10, filesPerChunk = 1) => {
    const maxFiles = this.getMaxAllowedFiles(true)
    const totalFiles = numberOfFiles > maxFiles ? maxFiles : numberOfFiles
    // const totalChunks = Math.ceil(totalFiles / filesPerChunk)
    this.setState(
      {
        totalChunks: 1, // we are sending backend the entire chunk
        chunkSize: totalFiles,
        chunking: true,
        showLayer: false,
        requestedFiles: totalFiles
      },
      () => this.processIndicies()
    )
  }
  loadFromAppSheet = () => {
    console.log('Loading from AppSheet')
    this.setState({ apiLoading: true })
    const responses = Promise.all([this.getPublishFiles()])
    responses
      .then((result) => {
        // const companies = result[1].data.data
        // const companyIdMap = {}
        const files = result[0].data.data
        // companies.forEach((comp) => (companyIdMap[comp.id] = comp))
        this.setState({
          apiLoading: false,
          files: files,
          // companiesById: companyIdMap,
          startAtId: files.length > 0 ? files[0].id : ''
        })
        console.log(result)
      })
      .catch((err) => this.context.actions.showResponseAsError(err))
  }
  componentDidMount() {
    this.loadFromAppSheet()
  }
  componentDidUpdate(prevProps, prevState, snapsho) {
    const startIndexChanged = prevState.nextStartIndex !== this.state.nextStartIndex
    const totalChunksChanged = prevState.totalChunks !== this.state.totalChunks
    const statusChanged = prevState.showStatus !== this.state.showStatus
    const companyChanged = prevState.selectedCompanyId !== this.state.selectedCompanyId
    const receiverChanged = prevState.selectedReceiverId !== this.state.selectedReceiverId
    const dateChanged = prevState.selectedDate !== this.state.selectedDate

    if (startIndexChanged && totalChunksChanged && this.state.totalChunks > 0) {
      this.processIndicies()
    }
    if (totalChunksChanged && this.state.totalChunks === 0) {
      this.setState({ chunking: false })
    }
    if (statusChanged || companyChanged || receiverChanged || dateChanged) {
      this.loadFromAppSheet()
    }
  }

  changeCompany = (data) => {
    if (data.receiver_type) {
      this.setState({ ...this.defaultState, selectedReceiverId: data.id })
    } else {
      this.setState({ ...this.defaultState, selectedCompanyId: data.id })
    }
  }

  changeStatus = (status) => {
    this.setState({ ...this.defaultState }, () => {
      this.setState({ showStatus: status })
    })
  }
  getMaxAllowedFiles = (withStartId = false) => {
    const { startAtId, files } = this.state
    return withStartId
      ? files.length - files.findIndex((file) => file.id === startAtId)
      : files.length
  }
  setStartAt = (id) => {
    const { files, selectedFileCount } = this.state

    this.setState(
      {
        startAtId: id,
        nextStartIndex: files.findIndex((file) => file.id === id)
      },
      () => this.setState({ selectedFileCount: this.getMaxAllowedFiles(true) })
    )
  }
  processSingleFile = (id) => {
    const { files } = this.state

    this.setState(
      {
        startAtId: id,
        nextStartIndex: files.findIndex((file) => file.id === id)
      },
      () => this.advance(1, 1)
    )
  }
  getSupplierReceiverName = (id, receiver = false) => {
    const { companies, receivers } = this.context
    if (!id) {
      return
    }
    if (receiver) {
      return receivers[id].name
    } else {
      return companies[id].name
    }
  }
  render() {
    const { companies, stores, receivers } = this.context
    const companiesById = companies
    const storesById = stores
    const receiversById = receivers
    const {
      selectedCompanyId,
      selectedReceiverId,
      files,
      submitting,
      apiLoading,
      completed,
      selectedDate,
      selectedChunkSize,
      selectedFileCount,
      selectedCustomIds,
      showJobSettings,
      startAtId
    } = this.state
    const completedFilesCount = Object.keys(completed).length
    const allowedMaxFiles = this.getMaxAllowedFiles(true)
    const rowItemMenuActions = {
      setStartAt: this.setStartAt,
      processSingleFile: this.processSingleFile
    }
    return (
      <Box fill>
        <PageHeader disabled={apiLoading} heading={'Publish Reports'}>
          <Heading level={5} margin="small">
            Files: {files.length}
          </Heading>
          <Box flex={'grow'} />
          <DropWithHeading
            primary
            label={startAtId + ', ' + selectedFileCount}
            icon={<SchedulePlay color={'dark-6'} />}
            heading={'JOB SETTINGS'}
            open={showJobSettings}
            onOpen={() => this.setState({ showJobSettings: true })}
            onClose={() => this.setState({ showJobSettings: false })}
          >
            <FormField label="# FILES" disabled={selectedCustomIds.length > 0}>
              <Select
                size="small"
                options={[...new Set([1, selectedFileCount, allowedMaxFiles].sort())]}
                value={selectedCustomIds.length > 0 ? selectedCustomIds.length : selectedFileCount}
                onChange={({ option }) => this.setState({ selectedFileCount: option })}
              />
            </FormField>
            <FormField label="# PER API CALL">
              <Select
                size="small"
                options={[...new Set([1, 2, allowedMaxFiles].sort())]}
                value={selectedChunkSize}
                onChange={({ option }) => this.setState({ selectedChunkSize: option })}
              />
            </FormField>
            <FormField
              label="START AT ID"
              help="Processing will start at this ID in the list"
              disabled={selectedCustomIds.length > 0}
            >
              <Box pad={'small'}>
                <Text color={'light-6'} weight={'bold'}>
                  {startAtId}
                </Text>
              </Box>
            </FormField>
            <FormField label="CUSTOM IDS">
              <TextInput
                value={JSON.stringify(selectedCustomIds)}
                onChange={(event) =>
                  this.setState({
                    selectedCustomIds: event.target.value ? JSON.parse(event.target.value) : []
                  })
                }
              />
            </FormField>
            <Box height="xxsmall" flex={'grow'}>
              <Button
                size="small"
                label="START PUBLISH"
                primary
                onClick={() => {
                  this.advance(selectedFileCount, selectedChunkSize)
                  this.setState({ showJobSettings: false })
                }}
              />
            </Box>
          </DropWithHeading>
          <DropWithHeading
            icon={<Filter color={'dark-6'} />}
            heading={'filters'}
            label={
              this.getSupplierReceiverName(
                selectedReceiverId || selectedCompanyId,
                selectedReceiverId
              ) || 'All'
            }
          >
            <FormField label="SUPPLIER / RECEIVER">
              <SelectSupplierReceiver
                plain
                value={{ companyId: selectedCompanyId, receiverId: selectedReceiverId }}
                onChange={({ option }) => this.changeCompany(option)}
              />
            </FormField>
            <FormField label="DATE">
              <Box
                pad={{ bottom: 'small' }}
                fill={'horizontal'}
                justify={'center'}
                align={'center'}
              >
                <Calendar
                  size={'small'}
                  date={selectedDate}
                  fill
                  onSelect={(date) => {
                    this.setState({ selectedDate: date })
                  }}
                />
              </Box>
            </FormField>
          </DropWithHeading>
          {/*{selectedCompanyId && (*/}
          {/*  <Button*/}
          {/*    icon={<DocumentDownload />}*/}
          {/*    onClick={() => this.setState({ showLayer: true })}*/}
          {/*  />*/}
          {/*)}*/}
        </PageHeader>

        <Main flex="shrink">
          {apiLoading ? (
            <Box fill align="center" justify="center">
              <GridLoader color={'#888'} loading={true} size={25} />
            </Box>
          ) : (
            <DataTable
              sortable
              primaryKey="id"
              pin
              resizeable
              rowDetails={FileDataRowDetails}
              columns={[
                {
                  property: 'id',
                  header: 'ID',
                  primary: true,
                  search: true
                },
                {
                  property: 'company_id',
                  header: 'Company',
                  size: 'small',
                  render: (datum) => (
                    <Box key={datum.company_id} pad={{ vertical: 'xsmall' }}>
                      <Text>
                        {companiesById[datum.company_id]
                          ? companiesById[datum.company_id].name
                          : ''}
                      </Text>
                    </Box>
                  )
                },
                {
                  property: 'store_id',
                  header: <Text>Store</Text>,
                  render: (datum) => (
                    <Box key={datum.store_id} pad={{ vertical: 'xsmall' }}>
                      <Text>
                        {storesById[datum.store_id] ? storesById[datum.store_id].name : ''}
                      </Text>
                    </Box>
                  )
                },
                {
                  property: 'receiver_id',
                  header: <Text>Receiver</Text>,
                  render: (datum) => (
                    <Box key={datum.receiver_id} pad={{ vertical: 'xsmall' }}>
                      <Text>
                        {receiversById[datum.receiver_id]
                          ? receiversById[datum.receiver_id].name
                          : ''}
                      </Text>
                    </Box>
                  )
                },
                {
                  property: 'entry_date',
                  header: <Text>ENTRY DATE</Text>,
                  size: 'xsmall'
                },
                {
                  property: 'file_change_time',
                  header: <Text>CHANGE TIME</Text>,
                  size: 'small'
                },
                {
                  property: 'file_type',
                  header: <Text>TYPE</Text>,
                  size: 'xxsmall',
                  render: (datum) => (
                    <Tip content={datum.file_type}>
                      <Text>{datum.file_type === 'CHARITY_REPORT' ? 'R' : 'P'}</Text>
                    </Tip>
                  )
                },
                {
                  render: (datum) => (
                    <RowItemMenu
                      key={datum.id}
                      rowData={datum}
                      currentStartAtId={startAtId}
                      actions={rowItemMenuActions}
                    />
                  )
                }
              ]}
              data={files}
            />
          )}
        </Main>

        {this.state.showLayer && (
          <Layer position="center" onClickOutside={() => this.setState({ showLayer: false })}>
            <Box
              gap="medium"
              pad="medium"
              round="small"
              width="medium"
              height="medium"
              align="center"
              justify="center"
              background="white"
              elevation="large"
            >
              {selectedCompanyId && <GeneratedFiles selectedCompanyId={selectedCompanyId} />}
            </Box>
          </Layer>
        )}
      </Box>
    )
  }
}

const RowItemMenu = ({ currentStartAtId, rowData, actions }) => (
  <Box width={'xxsmall'} height={'xxsmall'} flex={false}>
    <Menu
      icon={<MoreVertical />}
      items={[
        { label: 'Process Single file', onClick: () => actions.processSingleFile(rowData.id) },
        {
          label: 'Set as queue start',
          disabled: currentStartAtId === rowData.id,
          onClick: () => actions.setStartAt(rowData.id)
        }
      ]}
    />
  </Box>
)
RowItemMenu.propTypes = {
  currentStartAtId: PropTypes.string,
  rowData: PropTypes.object,
  actions: PropTypes.object
}

export default PublishFiles
